import _ from 'lodash';
import { ADMIN_URL, apiClient, apiErrorHandler } from 'src/app/common/network';
import { KeyTaskConfiguration, KeyTaskListParam, KeyTaskRecord } from '../types/key-task-summarizer-type';
import { PaginateList } from 'src/app/common/types';
import { getDayStart, getDayEnd } from 'src/app/common/utils/time-utils';

export const createKeyTaskSummarizer = async (
  configuration: KeyTaskConfiguration,
  dispatch?: Parameters<typeof apiErrorHandler>[1],
): Promise<void> =>
  apiClient
    .post<void>(`${ADMIN_URL}/key-task-summary/content`, configuration, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(() => undefined)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const updateKeyTaskSummarizer = async (
  id: string,
  configuration: Partial<KeyTaskConfiguration>,
  dispatch?: Parameters<typeof apiErrorHandler>[1],
): Promise<void> =>
  apiClient
    .patch<void>(`${ADMIN_URL}/key-task-summary/content/${id}`, configuration, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(() => undefined)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const fetchKeyTaskSummarizer = async (
  id: string,
  dispatch?: Parameters<typeof apiErrorHandler>[1],
): Promise<KeyTaskRecord> =>
  apiClient
    .get<KeyTaskRecord>(`${ADMIN_URL}/key-task-summary/content/detail/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });

export const fetchKeyTaskSummarizerList = async (
  params: Partial<KeyTaskListParam>,
  dispatch?: Parameters<typeof apiErrorHandler>[1],
): Promise<PaginateList<KeyTaskRecord>> => {
  const filteredParams = _.omitBy(
    {
      ...params,
      publishedStartDate: params.publishedStartDate
        ? getDayStart(params.publishedStartDate).toISOString()
        : undefined,
      publishedEndDate: params.publishedEndDate
        ? getDayEnd(params.publishedEndDate).toISOString()
        : undefined,
    },
    (value) => value == null || (typeof value === 'string' && (!value.trim() || value === 'all')),
  );

  return apiClient
    .get<PaginateList<KeyTaskRecord>>(`${ADMIN_URL}/key-task-summary/content`, {
      params: filteredParams,
    })
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
